import {
  faFacebook,
  faPinterestSquare,
  faTwitterSquare,
} from '@fortawesome/free-brands-svg-icons';

import {
  faAt,
  faPhone,
  faLifeRing,
  faCopyright,
  faStore,
  faIndustry,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';
import { DateSource } from '@shared/app/scripts/services/date-source';

/**
 * Holds footer logic
 */
angular.module('gateApp').component('swFooter', {
  template: require('./sw-footer.html').default,
  controller: class {
    year: Date;
    faFacebook: IconDefinition;
    faLifeRing: IconDefinition;
    faPinterestSquare: IconDefinition;
    faTwitterSquare: IconDefinition;
    faCopyright: IconDefinition;
    faStore: IconDefinition;
    faIndustry: IconDefinition;
    faAt: IconDefinition;
    faPhone: IconDefinition;

    constructor(private dateSource: DateSource) {
      this.faFacebook = faFacebook;
      this.faLifeRing = faLifeRing;
      this.faPinterestSquare = faPinterestSquare;
      this.faTwitterSquare = faTwitterSquare;
      this.faCopyright = faCopyright;
      this.faStore = faStore;
      this.faIndustry = faIndustry;
      this.faAt = faAt;
      this.faPhone = faPhone;

      this.year = this.dateSource.now();
    }
  },
});
